import { Box, Divider } from "@mui/material";
import StepOneUserForm from "learningFitbitLandingComponents/ProviderOnboardingComponents/StepOneUserForm";
import { useMemo, useState } from "react";
import PaymentSummary from "./PaymentSummary";
import RazorpayPayment from "./RazorpayPayment";
// import StepOneUserForm from "./StepOneUserForm";

const CheckoutPage = ({ plan, onPaymentSuccess, onUserSet }) => {
    const [user, setUser] = useState(null);
    const [coupon, setCoupon] = useState(null);

    console.log(plan, '-plans')

    // 💰 pricing logic (centralized)
    const pricing = useMemo(() => {
        const basePrice = Number(plan.price) || 0;
        const discount = coupon?.amount || 0;
        const finalAmount = Math.max(basePrice - discount, 0);

        return {
            basePrice,
            discount,
            finalAmount,
        };
    }, [plan, coupon]);

    const handleUserNext = (userData) => {
        setUser(userData);
        onUserSet(userData);   // ✅ SEND TO PARENT
    };

    return (
        <Box
        >

            {!user && (
                <StepOneUserForm planTitle={plan?.title} onNext={handleUserNext} />
            )}

            {user && (
                <>
                    <Divider sx={{ my: 2 }} />

                    <PaymentSummary
                        plan={plan}
                        pricing={pricing.basePrice}
                        discount={pricing.discount}
                        finalAmount={pricing.finalAmount}
                        onApplyCoupon={setCoupon}
                    />


                    <RazorpayPayment
                        user={user}
                        pricing={pricing.finalAmount}   // ✅ CORRECT
                        plan={plan}
                        coupon={coupon}
                        description={plan.title}
                        onSuccess={onPaymentSuccess}
                    />

                </>
            )}
        </Box>
    );
};

export default CheckoutPage;
